import { ISelectListItem } from "../../Core";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Xelect, { IXelectSettings, IXelectItemData, XelectItem } from "@brightspark/sparkling-xelect-js";

@Component
export default class XelectComponent extends Vue {

    @Prop({ default: false })
    public allowEmpty: boolean | undefined;

    @Prop({ default: "" })
    public classList: string;

    @Prop({ default: false })
    public multiselect: boolean | undefined;

    @Prop({ default: "" })
    public name: string | undefined;

    @Prop({ default: false })
    public autocomplete: boolean | undefined;   

    @Prop({ default: false })
    public forceValue: boolean | undefined;

    @Prop({ default: "" })
    public acUrl: string | undefined;

    @Prop({ default: new Array<IXelectItemData>() })
    public options: Array<IXelectItemData>;

    @Prop({ default: false })
    public readOnly: boolean | undefined;

    @Prop({ default: "" })
    public labelHint: string | undefined;

    @Prop({ default: "..." })
    public labelSearching: string | undefined;

    @Prop({ default: "" })
    public labelNotFound: string | undefined;

    @Prop()
    public instance: Xelect | undefined;

    @Prop()
    public value: string | undefined;

    private _xelect: Xelect | undefined;
    private _oldValue: string | undefined = "";
    private _shouldBlockChangeEvent: boolean = false;

    public mounted() {
        var options = {
            name: this.name,
            allowEmpty: this.allowEmpty,
            multiselect: this.multiselect,
            readOnly: this.readOnly,
            labels: {
                hint: this.labelHint,
                searching: this.labelSearching,
                noResults: this.labelNotFound
            }

        } as IXelectSettings;

        if (this.autocomplete) {
            options.type = "autocomplete";
            options.ac = {
                url: this.acUrl
            }
        }

        if (typeof this.forceValue !== "undefined") {
            options.forceValue = this.forceValue;
        }

        let node = this.$el.children[0] as HTMLElement;
        this._xelect = new Xelect(node ? node : this.$el, options);

        if (this.options.length) {
            this.onOptionsChange(this.options, [] as Array<IXelectItemData>);
        }

        this._xelect.change(x => {
            if (this._shouldBlockChangeEvent) {
                return;
            }

            if (x) {
                if (x.value == this._oldValue) {
                    return;
                }
                this.$emit('update-value', x.value, this);

            } else if (!!this._oldValue) {
                this.$emit('update-value', undefined, this);
            }

            this._oldValue = x ? x.value : "";
        });

        this._xelect.onSelect(() => {
            var input = (this._xelect as any).el_input;
            if (input) {
                input.blur();
            }
        });

        this.$emit('update-instance', this._xelect);
    }

    @Watch('options')
    onOptionsChange(options: Array<IXelectItemData>, oldVal: Array<IXelectItemData>) {
        if (!this._xelect || !options) {
            return;
        }
        this._shouldBlockChangeEvent = true;
        let selectedValue = this._xelect.getSelectedItem() as IXelectItemData;
        let isThereSelectedValue = false;
        let defaultValue: IXelectItemData | null = null;
        
        for (let i = 0; i < options.length; i++) {
            let option = options[i];
            if (selectedValue && option.value === selectedValue.value) {
                option.selected = true;
            }
            if (!option.value) {
                defaultValue = option;
            }

            isThereSelectedValue = isThereSelectedValue || Boolean(option.selected);
        }

        if (!isThereSelectedValue && defaultValue !== null) {
            defaultValue.selected = true;
        }

        this._xelect.clearOptions();
        this._xelect.addOptions(options);
        this._shouldBlockChangeEvent = false;
    }
}


// WEBPACK FOOTER //
// ./www/js/Components/Xelect/XelectComponent.ts